<template>
  <nav
    id="navbar"
    class="nav"
    :class="{
      'py-2': hideMenu === true,
    }"
  >
    <v-container class="bar" fluid>
      <v-row class="fill-height" align="center" justify="start">
        <v-col
          class="logo-wrapper pa-md-0"
          cols="6"
          offset-md="1"
          :md="checkScreenSize ? 1 : 2"
        >
          <router-link to="/" class="logo">
            eureciclo
            <picture>
              <source
                media="(max-width: 959px)"
                srcset="@/assets/images/logo-eureciclo-mobile1.png"
              />
              <source
                media="(min-width: 960px) and (max-width: 1439px)"
                srcset="@/assets/images/logo-eureciclo-mobile2.png"
              />
              <source
                media="(min-width: 1440px)"
                srcset="@/assets/images/logo-eureciclo-desktop.png"
              />
              <img
                src="@/assets/images/logo-eureciclo-desktop.png"
                alt="eureciclo"
              />
            </picture>
          </router-link>
        </v-col>
        <v-col
          v-if="hideMenu === false"
          cols="6"
          :md="checkScreenSize ? 9 : 8"
          class="pa-md-0"
        >
          <v-row
            v-if="$vuetify.breakpoint.mdAndUp"
            class="ma-md-0 pa-md-0 justify-md-end"
            align="center"
          >
            <MegaMenu
              :items="megaMenuItems"
              :hide-for-oq-sucos="hideForOqSucos"
              :hide-for-clients-lps="hideForClientsLps"
            />
            <v-col cols="auto">
              <a
                href="https://checkout-ms.eureciclo.io/checkout/prices"
                class="checkout-button"
                target="_blank"
              >
                Compre Online
              </a>
            </v-col>
            <v-col
              v-if="hideForOqSucos === false || hideForClientsLps === false"
              cols="auto"
              :align="$vuetify.breakpoint.mdAndUp ? 'end' : 'center'"
              class="login-menu-wrapper"
            >
              <v-menu open-on-hover offset-y>
                <template v-slot:activator="{ on }">
                  <a v-on="on">Entrar</a>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in loginItems"
                    :key="index"
                    :href="item.url"
                    target="_blank"
                    link
                    class="login-menu-item"
                  >
                    <v-list-item-title
                      @click="analytics(item)"
                      v-text="item.title"
                    />
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
          <v-row v-if="$vuetify.breakpoint.smAndDown">
            <v-col class="d-flex justify-end py-0">
              <a class="hamburger-menu-wrapper" @click="toggleNavDrawer">
                <span class="line"></span>
              </a>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-navigation-drawer
      v-model="isMenuOpen"
      app
      temporary
      height="calc(100vh - 64px)"
      width="100vw"
    >
      <v-list>
        <template v-for="(item, p) in megaMenuItems">
          <template v-if="item.submenu">
            <v-list-group :key="'parent' + p">
              <template v-slot:activator>
                <v-list-item-title class="parent-title">
                  {{ item.parentTitle }}
                </v-list-item-title>
              </template>
              <template v-for="(subItem, s) in item.submenu">
                <v-list-item-title :key="'subitem' + s">
                  <h3>
                    {{ subItem.title }}
                  </h3>
                </v-list-item-title>
                <div
                  v-for="(child, c) in subItem.childrens"
                  :key="'subitem' + s + '-child' + c"
                  class="pa-0 ma-0"
                >
                  <v-list-item link :to="child.url" @click="updatePersona">
                    <v-list-item-title>
                      {{ child.title }}
                    </v-list-item-title>
                  </v-list-item>
                </div>
              </template>
            </v-list-group>
          </template>
          <template v-else>
            <v-list-item :key="p" link :to="item.url" @click="updatePersona">
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item>
          </template>
        </template>
      </v-list>
      <template v-slot:append>
        <div class="pa-2 footer-menu-drawer">
          <v-list-item>
            <v-list-item-content>
              <v-btn
                rounded
                large
                width="230"
                href="https://checkout-ms.eureciclo.io/checkout/prices"
                target="_blank"
                class="outline-color"
                @click="callbackPerson()"
              >
                Compre Online
              </v-btn>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="login-menu-wrapper">
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-title class="parent-title">
                  Entrar
                </v-list-item-title>
              </template>
              <v-list-item
                v-for="(item, index) in loginItems"
                :key="index"
                :href="item.url"
                target="_blank"
                link
              >
                <v-list-item-title
                  @click="analytics(item)"
                  v-text="item.title"
                />
              </v-list-item>
            </v-list-group>
          </v-list-item>
        </div>
      </template>
    </v-navigation-drawer>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  components: {
    MegaMenu: () => import('@/components/Navbars/MegaMenu.vue'),
  },
  props: {
    background: {
      type: String,
      required: false,
      default: '',
    },
    eventCategoryButton: {
      type: String,
      required: false,
      default: '',
    },
    buttonScroll: {
      type: String,
      required: false,
      default: '',
    },
    dark: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isMenuOpen: false,
      megaMenuItems: [
        {
          parentTitle: 'A eureciclo',
          submenu: [
            {
              title: 'Sobre',
              childrens: [
                {
                  title: 'Quem Somos',
                  description:
                    'Conheça a história da eureciclo e saiba mais sobre o propósito da nossa atuação',
                  url: '/sobre/aeureciclo',
                  eventCategory: 'menu-sobre',
                  eventLabel: 'quem_somos',
                },
                {
                  title: 'Nossa Solução',
                  description:
                    'Entenda como funciona a nossa tecnologia por trás da compensação ambiental',
                  url: '/sobre/nossa-solucao',
                  eventCategory: 'menu-sobre',
                  eventLabel: 'nossa_solucao',
                },
                {
                  title: 'Selo',
                  description:
                    'Veja quais são as vantagens de carregar o selo eureciclo nas suas embalagens',
                  url: '/sobre/selo',
                  eventCategory: 'menu-sobre',
                  eventLabel: 'o_selo',
                },
                {
                  title: 'Q & A',
                  description:
                    'Acesse as perguntas e respostas mais recorrentes para solucionar suas dúvidas',
                  url: '/sobre/faq',
                  eventCategory: 'menu-sobre',
                  eventLabel: 'faq',
                },
                // {
                //   title: 'Consumo Consciente',
                //   description: '',
                //   url: '',
                //   eventCategory: 'menu-sobre',
                //   eventLabel: 'consumo_consciente',
                // },
              ],
            },
            {
              title: 'Marcas',
              childrens: [
                {
                  title: 'Quem usa',
                  description:
                    'Confira as marcas que investem na cadeia de reciclagem e carregam o nosso sorriso',
                  url: '/marcas',
                  eventCategory: 'menu-marcas',
                  eventLabel: 'listagem_marcas',
                },
                {
                  title: 'Cases de reciclagem',
                  description:
                    'Conheça os cases de sucesso da nossa parceria com marcas de diversos portes e setores',
                  url: '/marcas/cases',
                  eventCategory: 'menu-marcas',
                  eventLabel: 'listagem_cases',
                },
              ],
            },
            {
              title: 'Legislação',
              childrens: [
                {
                  title: 'Nacional',
                  description: '',
                  url: '/leis-e-decretos',
                  eventCategory: 'menu-legislacao',
                  eventLabel: 'legislacao_nacional',
                },
                // {
                //   title: 'Recicla +',
                //   description: '',
                //   url: '/lp-legislacao',
                //   eventCategory: 'menu-legislacao',
                //   eventLabel: 'recicla_mais',
                // },
                // {
                //   title: 'PNRs',
                //   description: '',
                //   url: '',
                //   eventCategory: 'menu-legislacao',
                //   eventLabel: 'PNRs',
                // },
              ],
            },
          ],
        },
        {
          parentTitle: 'Negócios',
          submenu: [
            {
              title: 'O que fazemos para sua marca?',
              childrens: [
                {
                  title: 'Empresa',
                  description: '',
                  url: '/empreendedores',
                  eventCategory: 'menu-negocios',
                  eventLabel: 'empresas',
                },
                {
                  title: 'Corporações',
                  description: '',
                  url: '/corporacoes',
                  eventCategory: 'menu-negocios',
                  eventLabel: 'corporacoes',
                },
              ],
            },
            {
              title: 'O que fazemos para nossos parceiros?',
              childrens: [
                {
                  title: 'Associações',
                  description: '',
                  url: '/associacoes',
                  eventCategory: 'menu-parceiros',
                  eventLabel: 'associacoes',
                },
                {
                  title: 'Centrais de triagem',
                  description: '',
                  url: '/centrais-de-triagem',
                  eventCategory: 'menu-parceiros',
                  eventLabel: 'centrais_de_triagem',
                },
                {
                  title: 'Consumidores',
                  description: '',
                  url: '/consumidores',
                  eventCategory: 'menu-parceiros',
                  eventLabel: 'consumidores',
                },
              ],
            },
          ],
        },
        {
          parentTitle: 'Conteúdos',
          submenu: [
            {
              title: 'Impacto eureciclo',
              childrens: [
                {
                  title: 'Relatório de Desempenho',
                  description: '',
                  url: 'https://info.eureciclo.com.br/relatorio_desempenho2023',
                  eventCategory: 'menu-impacto',
                  eventLabel: 'relatorio_de_desempenho',
                  external: true,
                },
                {
                  title: 'eureciclo Impacta',
                  description: '',
                  url:
                    'https://blog.eureciclo.com.br/programa-eureciclo-impacta/',
                  eventCategory: 'menu-impacto',
                  eventLabel: 'eureciclo_impacta',
                  external: true,
                },
              ],
            },
            {
              title: 'Sustentabilidade',
              childrens: [
                {
                  title: 'Blog',
                  description:
                    'Artigos novos toda semana para manter você e sua empresa atualizados no universo da sustentabilidade.',
                  url: 'https://blog.eureciclo.com.br/',
                  eventCategory: 'menu-sustentabilidade',
                  eventLabel: 'blog_eureciclo',
                  external: true,
                },
                {
                  title: 'Ebook e Conteúdos ESG',
                  description:
                    'Materiais gratuitos e aprofundados para desenvolver a jornada de impacto positivo da sua empresa.',
                  url: '/aprenda/ebook-guias-e-mais',
                  eventCategory: 'menu-sustentabilidade',
                  eventLabel: 'ebook_e_conteudos_esg',
                },
                // {
                //   title: 'Eventos',
                //   description:
                //     'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                //   url: '/aprenda/ebook-guias-e-mais',
                //   eventCategory: 'menu-sustentabilidade',
                //   eventLabel: 'a_eureciclo',
                // },
                // {
                //   title: 'Omnichannel',
                //   description:
                //     'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                //   url: '/aprenda/ebook-guias-e-mais',
                //   eventCategory: 'menu-sustentabilidade',
                //   eventLabel: 'a_eureciclo',
                // },
              ],
            },
            // {
            //   title: 'Imprensa',
            //   childrens: [
            //     {
            //       title: 'Na mídia',
            //       description:
            //         'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            //       url: '',
            //       eventCategory: 'menu-sobre',
            //       eventLabel: 'a_eureciclo',
            //     },
            //   ],
            // },
          ],
        },
        {
          title: 'Atendimento',
          description:
            'Dúvidas? Entre em contato com a nossa equipe de especialistas',
          url: '/contato',
          eventCategory: 'menu-atendimento',
          eventLabel: 'contato',
        },
      ],
      color: '#59595c',
      loginItems: [
        {
          title: 'Área do Cliente',
          url: 'https://empresas.nhecotech.com',
          eventAction: 'choose-area-do-cliente',
        },
        {
          title: 'Área do Operador',
          url: 'https://eureciclo.operadores.com.br',
          eventAction: 'choose-area-do-operador',
        },
      ],
      hideMenu: false,
      hideForOqSucos: false,
      hideForClientsLps: false,
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    // name() {
    //   if (this.$store.state.persona.selected.name) {
    //     this.updateBrandLink();
    //     return `Você é: ${this.$store.state.persona.selected.name}`;
    //   }
    //   return 'Escolha seu perfil';
    // },
    // persona() {
    //   return null;
    // },
    // checkClass() {
    //   if (document.querySelector('.new-color')) {
    //     this.changeColor('#003036');
    //     return true;
    //   }
    //   return false;
    // },
    checkScreenSize() {
      if (window.innerWidth >= 960 && window.innerWidth <= 1399) {
        return true;
      }
      return false;
    },
  },
  created() {
    if (window.scrollY >= 10) {
      this.scrolling = true;
    }
    // this.updateBrandLink();
    window.addEventListener('scroll', this.handleScroll);

    if (this.$route.name === 'burle' || this.$route.name === 'onda-circular') {
      this.hideMenu = true;
    }
    if (
      this.$route.name === 'oqbebidassaudaveis' ||
      this.$route.name === 'solucoes-eureciclo'
    ) {
      this.hideForOqSucos = true;
    }
    if (this.$route.name === 'lp-demo') {
      this.hideForClientsLps = true;
    }
  },
  methods: {
    analytics(route) {
      if (window.location.pathname !== route.link) {
        this.$analytics('personas', route.eventAction, 'expand');
      }
    },
    changeColor(val) {
      this.color = val;
    },
    updatePersona(eventCategory, eventLabel) {
      const actualPersona = this.$store.state.persona.selected;
      const personaUpdated = this.$store.state.persona.personas.find(
        persona => persona.name === actualPersona.name,
      );
      this.$store.commit('persona/updateSelected', personaUpdated);
      if (eventCategory || eventLabel) {
        this.$analytics(eventCategory, 'click', eventLabel);
      }
    },
    toggleNavDrawer() {
      this.isMenuOpen = !this.isMenuOpen;
      document
        .querySelector('.hamburger-menu-wrapper')
        .classList.toggle('active');
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

#navbar
  background-color: #ffffff
  position: fixed
  width: 100vw
  min-height: 72px
  overflow: visible
  border-bottom: 1px solid #26D07C
  @media screen and (max-width: 1199px)
    min-height: auto
  z-index: 999
  .container
    >.row
      max-width: 100%
    @media screen and (max-width: 1199px)
      padding: 0 12px
    @media screen and (min-width: 1200px)
      padding: 0
  .logo-wrapper
    .logo
      display: block
      font-size: 0
      line-height: 0
      cursor: pointer
      @media screen and (min-width: 960px) and (max-width: 1399px)
        overflow: hidden
      @media screen and (min-width: 960px) and (max-width: 991px)
        max-width: 70px
      @media screen and (min-width: 992px)
        img
          max-height: 37px
      @media screen and (min-width: 1201px) and (max-width: 1399px)
        max-width: 56px
  .checkout-button
    background: #3DCF8E
    position: relative
    display: block
    font-family: 'metropolisbold'
    font-style: normal
    font-weight: 700
    font-size: 16px
    line-height: 24px
    text-transform: uppercase
    color: #FFFFFF
    align-items: center
    padding: 8px 48px
    border-radius: 20px
    outline: none
    text-decoration: none
    transition: all 0.3s ease-in-out
    &:hover
      background: #003036
      transition: all 0.3s ease-in-out
  .login-menu-wrapper
    a
      background: url("~@/assets/images/navbar/login-icon.png") center left no-repeat
      font-family: 'metropolisregular'
      font-style: normal
      font-weight: 400
      font-size: 16px
      line-height: 24px
      color: #231F20
      padding: 26px 0 26px 39px
      transition: 0.3s all ease-in-out
      &:hover
        text-shadow: 0 0 .65px #003036, 0 0 .65px #003036, 0 0 .65px #003036
        transition: 0.3s all ease-in-out
  .hamburger-menu-wrapper
    background: transparent
    position: relative
    display: flex
    justify-content: center
    align-items: center
    height: 36px
    width: 38px
    border-radius: 100px
    transition: .5s ease-in-out
    .line
      background: #231F20
      position: relative
      display: block
      width: 26px
      height: 3px
      border-radius: 50px
      -webkit-transform-origin: center
      transform-origin: center
      -webkit-transition: .5s ease-in-out
      transition: .5s ease-in-out
      &:after,
      &:before
        background: #231F20
        content: ""
        position: absolute
        display: block
        width: 100%
        height: 100%
        border-radius: 50px
        -webkit-transition: .5s ease-in-out
        transition: .5s ease-in-out
      &:before
        top: -10px
      &:after
        bottom: -10px
    &.active
      background: #EEFBF5
      transition: .5s ease-in-out
      .line
        background: #003036
        -webkit-transform: rotate(45deg)
        transform: rotate(45deg)
        &:after,
        &:before
          background: #003036
        &:after
          -webkit-transform: rotate(90deg)
          transform: rotate(90deg)
          bottom: 0
        &:before
          -webkit-transform: rotate(90deg)
          transform: rotate(90deg)
          top: 0
.login-menu-item
  width: 100%
  height: 100%
  min-height: auto
  padding: 10px 15px
  display: block
  font-family: 'metropolisregular'
  font-style: normal
  font-weight: 400
  font-size: 18px
  line-height: 27px
  color: #231F20
  text-decoration: none
  cursor: pointer
  transition: 0.3s
  &:hover
    text-shadow: 0 0 .65px #231f20, 0 0 .65px #231f20, 0 0 .65px #231f20
  &:before,
  &:after
    display: none
.v-navigation-drawer
  top: 64px !important
  .v-list
    .v-list-group
      .v-list-item
        .parent-title
          font-family: 'metropolisregular'
          font-weight: 400
          font-size: 18px
          line-height: 27px
          color: #231F20
          text-decoration: none
          outline: none
          transition: 0.3s all ease-in-out
          &:hover
            color: #003036
            text-shadow: 0 0 .65px #003036, 0 0 .65px #003036, 0 0 .65px #003036
            transition: 0.3s all ease-in-out
      ::v-deep
        .v-list-group__items
          padding: 0 16px 30px
          >.v-list-item__title
            h3
              font-family: 'metropolisregular'
              font-style: normal
              font-weight: 700
              font-size: 20px
              line-height: 1
              color: #231F20
              padding: 30px 0 10px 20px
              margin: 0
          .v-list-item--link
            padding-left: 32px
            .v-list-item__title
              width: 100%
              height: 100%
              display: block
              font-family: 'metropolisregular'
              font-style: normal
              font-weight: 400
              font-size: 18px
              line-height: 1
              color: #231F20
              text-decoration: none
              cursor: pointer
              transition: 0.3s
              &:hover
                text-shadow: 0 0 .65px #231f20, 0 0 .65px #231f20, 0 0 .65px #231f20
        .v-list-item--link:before,
        .v-list-item--link:after
          display: none
    .v-list-item--link
      .v-list-item__title
        font-family: 'metropolisregular'
        font-weight: 400
        font-size: 18px
        line-height: 27px
        color: #231F20
        text-decoration: none
        outline: none
        transition: 0.3s all ease-in-out
        &:hover
          color: #003036
          text-shadow: 0 0 .65px #003036, 0 0 .65px #003036, 0 0 .65px #003036
          transition: 0.3s all ease-in-out
  .footer-menu-drawer
    background: #F2F2F3
    ::v-deep
      .v-list-group__header
        padding: 0
    .login-menu-wrapper
      width: 100%
      display: block
      ::v-deep
        &:before,
        &:after,
        .v-list-item__icon
          display: none
        .v-list-group__items
          a
            background: none !important
            text-align: center
            padding: 20px 0 !important
            border-bottom: 1px solid #CDCDD0
      .parent-title
        background: #F2F2F3
        position: relative
        display: flex
        justify-content: center
        align-items: center
        font-family: 'metropolisregular'
        font-style: normal
        font-weight: 400
        font-size: 16px
        line-height: 24px
        color: #231F20
        text-align: center
        border: 1px solid #CDCDD0
        border-radius: 20px
        padding: 7px 0
        transition: 0.3s all ease-in-out
        &:hover
          text-shadow: 0 0 .65px #003036, 0 0 .65px #003036, 0 0 .65px #003036
          transition: 0.3s all ease-in-out
        &:before
          background: url("~@/assets/images/navbar/login-icon.png") center center no-repeat
          content: ""
          position: relative
          display: block
          width: 24px
          height: 24px
          margin-right: 15px
</style>
